// Depoimentos estáticos (avaliações reais do Google), ordenados por relevância.
// Para adicionar novos depoimentos, edite este arquivo manualmente.

export type Depoimento = {
  id: string;
  author_name: string;
  comment: string;
  rating: number;
  review_created_at: string;
};

export const DEPOIMENTOS: Depoimento[] = [
  {
    "id": "manual-priscila-chaves",
    "author_name": "Priscila Chaves",
    "comment": "A melhor iniciativa da Fisioterapia para os Fisioterapeutas não só do Brasil pois moro em Portugal e me beneficio muito com os conteúdos da melhor qualidades. Sou assinante da Star e não poderia estar mais satisfeita.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "manual-millene-beatriz",
    "author_name": "Millene Beatriz",
    "comment": "O melhor portal para se aprender sobre Fisioterapia, sempre atualizado e com profissionais de excelência. Muito obrigada por viabilizar essa oportunidade para nós graduandos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "manual-bruno-teixeira",
    "author_name": "Bruno Teixeira Fisioterapeuta",
    "comment": "Sem dúvidas o Fisio em Ortopedia, é uma das melhores plataformas de ensino dentro da Fisioterapia! Sempre alinhando as melhores evidências científicas a prática clínica fisioterapêutica, com conteúdos de altíssimo nível e um corpo docente de altíssimo nível técnico!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "72e85dd3-4526-461b-b5d0-0902ba3694fa",
    "author_name": "Katia Silva",
    "comment": "Conteúdo bom, tudo embasado em PBE.",
    "rating": 5,
    "review_created_at": "2026-06-07"
  },
  {
    "id": "93d1384c-4216-47e3-b988-208bdab6e663",
    "author_name": "Vanessa Moraes",
    "comment": "Melhores cursos, estou amando.",
    "rating": 5,
    "review_created_at": "2026-06-07"
  },
  {
    "id": "d0911795-be40-4f22-81b2-ed49af290f02",
    "author_name": "Isabelle Lopes",
    "comment": "Muito fácil de acessar e tem cursos gratuitos que enriquecem o nosso conhecimento diário.",
    "rating": 5,
    "review_created_at": "2026-05-07"
  },
  {
    "id": "1cb9f669-f53a-43e4-b500-7985dbbd3d5d",
    "author_name": "Juliana Santos",
    "comment": "Informações atualizadas e objetivas. Obrigada.",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "bf5c46c8-dd5b-4dfc-b554-517ab6aa1b47",
    "author_name": "Larissa Costa",
    "comment": "Ótimos cursos e professores!!!",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "d0a20e52-62b4-4b1f-b10e-24ed2bb41be4",
    "author_name": "Victor Hugo Fernandes",
    "comment": "Corpo docente extremamente capacitado, ótima didática, tudo baseado em evidência, atualizações importantíssimas para a tomada de decisão na prática clínica.",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "ccd541ab-d0ff-47b5-ad0f-9e7f57e03b71",
    "author_name": "Fabíola R C S",
    "comment": "Gostei da aula, do fácil acesso e do custo-benefício.",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "1c518d35-3168-451a-99f3-c96392384b67",
    "author_name": "Matheus Almeida",
    "comment": "Excelente! O trabalho que eles fazem para fortalecer a fisioterapia é incrível. Estão de parabéns.",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "92a67735-389c-4c78-821b-5911b987727e",
    "author_name": "Larisse Monteiro",
    "comment": "Plataforma muito boa, de muita qualidade e atualização, que tem nos ajudado de forma produtiva.",
    "rating": 5,
    "review_created_at": "2026-04-07"
  },
  {
    "id": "286ac5bd-7425-4690-8e6e-f1c50e0bac99",
    "author_name": "Isabella Avila",
    "comment": "Conteúdo ótimo",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "f52c1b00-3e78-4233-82ab-90654cf7bd53",
    "author_name": "Leylane Novaes",
    "comment": "Creio que será de muito aproveitamento.",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "d97d1dcc-25c8-4bd7-8128-e413d817d15d",
    "author_name": "Gabriella Rezende",
    "comment": "Todos os conteúdos ofertados são ricos em informações, bastante completos e satisfatórios no ganho de conhecimentos específicos.",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "7a40aef7-2bd8-4cf6-9297-22c4b5998ece",
    "author_name": "Artur Paiva dos Santos Sánchez",
    "comment": "Das melhores formações que tenho na minha vida acadêmica e clínica.",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "855679c9-8b7b-4dd9-b469-af83c4a5e8fa",
    "author_name": "Vera Lucia Fantausse",
    "comment": "Sou portadora de parestesia bilateral e tive o prazer de conhecer e participar de seções de fisioterapia com o profissional em questão, além do mesmo acompanhar as minhas aulas de musculação dando todas as orientações pertinentes.",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "4052b71a-3997-4c3e-8128-6713eac452b3",
    "author_name": "Eli Antoni Carvalho",
    "comment": "As aulas são maravilhosas, didática no ensino e os vídeos são de alta qualidade, com conteúdos muito legais para melhora do aprendizado.",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "a4fa1521-0a4d-4552-ab71-4c9dacc8bf1d",
    "author_name": "Ligia Mates",
    "comment": "Aulas ótimas, tópicos bem explicados, fácil de entender apesar do tema ser complexo. Professores que dominam o assunto. Excelente!",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "0a2716a9-60dc-4c2d-ae2f-69e77c3a0a43",
    "author_name": "Luiz Edjanio",
    "comment": "Excelentes professores, que ensinam o que tem de mais novo nas literaturas!",
    "rating": 5,
    "review_created_at": "2026-03-07"
  },
  {
    "id": "7706d06c-82d3-4532-90fd-cf503dbd71d5",
    "author_name": "Narumi Nobusawa",
    "comment": "Tá sendo maravilhosa 😍",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "7a2449f8-8caa-42d5-a97f-eb9039efab65",
    "author_name": "Aline Rodrigues Câmara",
    "comment": "Tudo em um só lugar! Simples e prático!",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "9b320274-290f-4f1f-a643-d8d3a0deee88",
    "author_name": "Felipe Toledo",
    "comment": "Cara, que conteúdo de altíssima qualidade! É ótimo para todo mundo da área da saúde entender um pouco mais sobre o corpo e as suas fisiopatologias.",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "0377e1b0-d7b2-41b5-9251-da1dc06b5f76",
    "author_name": "Maria Eduarda A. de Meira",
    "comment": "Eu sou fã da Fisio em Ortopedia. Portal completo, bem estruturado, conteúdos de qualidade.",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "e443e727-4235-4d93-8cad-cdf769b86610",
    "author_name": "Otavio Henrique Breyer",
    "comment": "Sinceramente eu estou amando a pós-graduação em ortopedia e traumatologia. Além disso, a atmosfera com a comunidade e cursos no Star deixam a experiência ainda melhor. Parabéns pela empresa e conteúdo que vocês compartilham!",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "e0dd3a2e-fd7a-4f25-bb40-5678e670198a",
    "author_name": "Pat Claro",
    "comment": "Melhor plataforma de estudos para fisioterapeutas. Professores muito didáticos, atenciosos, sem dúvida melhor investimento. Parabéns Fisio em Ortopedia, faz muita diferença na minha prática clínica 🙏",
    "rating": 5,
    "review_created_at": "2026-02-07"
  },
  {
    "id": "714f7a8b-6dc2-4176-86e2-48f96bd05924",
    "author_name": "Luana Moreira",
    "comment": "Maravilhosa, curso bastante enriquecedor.",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "fe81a6e3-dff9-4391-ac33-217ef4da46ea",
    "author_name": "Joyce Borges",
    "comment": "Muito bom, amei!",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "3c8902b7-2081-4425-86fa-78c27d878c74",
    "author_name": "Cléia Lima Rocha",
    "comment": "Excelente empresa, tanto nos conteúdos quanto no suporte de assistência.",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "4f193ac2-48a7-45f1-9cc4-c2b3f40272d7",
    "author_name": "José Fernando",
    "comment": "Foi ótima. O aprendizado não deve se encerrar jamais, pelo contrário, aumenta os conhecimentos e nos leva para novos caminhos.",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "a537cc83-85b0-4185-b913-e6e3485723a2",
    "author_name": "Rodrigo Prado",
    "comment": "Melhor empresa de cursos em fisioterapia. Um preço tão baixo e um valor absurdo!",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "81423124-c876-48f6-85d7-9293f704c465",
    "author_name": "juliana Farias",
    "comment": "Super recomendo. Excelentes profissionais, os cursos são ótimos.",
    "rating": 5,
    "review_created_at": "2026-01-07"
  },
  {
    "id": "88da8cdc-e539-42e3-8cf9-e6b0da32ad2e",
    "author_name": "G.N_Training",
    "comment": "Portal riquíssimo em conteúdos com grandes professores e com uma didática clara objetiva e de qualidade.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "06d3b766-955a-42b3-af00-08866824e860",
    "author_name": "Tiago Freddi",
    "comment": "Tinha minhas ressalvas sobre EAD, porém dei uma chance pra FEO e estou curtindo muito, aulas bem didáticas e com excelentes professores.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "5825a116-360a-49ef-ba36-7813110d9d58",
    "author_name": "Rosane Fernandes",
    "comment": "Estou muito feliz com esse curso, ainda iniciando pela qualidade do curso tenho certeza que vai me agregar mais conhecimento.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "734a63a5-2804-44ed-8afa-6f31963b390d",
    "author_name": "Fisioterapeuta José Edson França",
    "comment": "Cursos excelentes, professores capacitados e site de fácil manejo. Para fisioterapeutas iniciantes que querem se especializar ou mais experientes que desejam se aprofundar, creio que é a melhor opção online que temos no país.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "bfa19bf6-3538-4177-8b46-c4c8826dc14e",
    "author_name": "Lucinaldo Santos Lira",
    "comment": "A campanha tocou e fui averiguar e vi que era a Fisio em Ortopedia me presenteando com este magnífico curso, e assim espero receber o certificado e representá-los por onde eu passar.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "eaad0d38-b3c4-45c6-acad-ea22bc098627",
    "author_name": "Katia Martins",
    "comment": "Amei a experiência 🥰 professores super qualificados e me deu mais segurança ainda com laser. Gratidão 🙏",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "3c098e53-1f8d-43e8-b2a1-93381ee2aa41",
    "author_name": "FLAVIA MAGLIANO",
    "comment": "Cursos maravilhosos e muito bem explicativos.",
    "rating": 5,
    "review_created_at": "2025-12-07"
  },
  {
    "id": "6d512a1f-8adc-4325-898f-580b943772e0",
    "author_name": "Lorena Camargos",
    "comment": "Fiz a pós graduação em especialista em dor e foi uma virada de chave na minha carreira como Fisioterapeuta",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "128aded4-d24d-4f35-bdae-2758fd6201fa",
    "author_name": "Clailton Nascimento",
    "comment": "Muito bom ótimo site",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "ae9c863d-79aa-42f6-a02e-e3c5746cff56",
    "author_name": "Raphael Otoni",
    "comment": "Não tenho nada para falar por enquanto",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "ccc38a2a-b9e1-4b65-b5b3-a73dfff13d5a",
    "author_name": "Laura Braga",
    "comment": "A experiência foi muito boa!!",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "c8a7c981-6a3e-4a42-a57d-6faabc1fbb43",
    "author_name": "quetsia freitas",
    "comment": "De extrema importância e conta com o cuidado na informação de excelência",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "92c4f94c-2df2-4cb4-b92a-dc6881b37fbd",
    "author_name": "Mariano Neto",
    "comment": "Ótimos conteúdos e informações.",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "cec52b6c-23fd-4827-9353-60aca727edfb",
    "author_name": "Juliana Lopes",
    "comment": "Gratidão por esse curso incrível e pela chance de aprimorar meus conhecimentos em fisioterapia!",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "0bbb53f7-d2b3-4f55-91ef-2885c91fc2fc",
    "author_name": "Clemilson Melo Duarte",
    "comment": "Parabéns pelos conteúdos e iniciativa.",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "c421f2c3-7b62-492e-8720-5b8815f351fb",
    "author_name": "Fábio Bento",
    "comment": "Agregou muito ao meu ganho de conhecimentos.",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "dbf9d3ab-8130-4a2f-986c-dc6e60ba8a89",
    "author_name": "Marcelo Lucindo",
    "comment": "Achei a didática e todo o contexto excelente. Gostei das apresentações dos professores, com conhecimentos e domínio em suas aulas. Parabéns.",
    "rating": 5,
    "review_created_at": "2025-11-07"
  },
  {
    "id": "d9b0d757-4b1e-4ec1-bccc-b70c01b054b3",
    "author_name": "Miss Grasiela Azevedo",
    "comment": "A aula gratuita foi muito proveitosa, com conteúdo claro, didática excelente e abordagens que despertaram grande interesse pelo tema.",
    "rating": 5,
    "review_created_at": "2025-10-07"
  },
  {
    "id": "66924191-3b80-41a8-9ce9-555b287d4654",
    "author_name": "Hiago Coutinho",
    "comment": "A Fisio em Ortopedia é, sem dúvida, uma das melhores plataformas de estudos e atualizações para fisioterapeutas. Oferece pós-graduações, imersões, cursos, certificações e muitos outros conteúdos relevantes, todos baseados em evidências.",
    "rating": 5,
    "review_created_at": "2025-10-07"
  },
  {
    "id": "4ee49fbe-994f-4ef3-853e-736235381c8b",
    "author_name": "Stella Maris",
    "comment": "Estou gostando bastante dos cursos das \"trilhas\", me ajudou bastante a relembrar assuntos abordados durante a graduação. A didática e a qualidade dos vídeos são excelentes.",
    "rating": 5,
    "review_created_at": "2025-10-07"
  },
  {
    "id": "073b2c4d-9fd0-4f61-b461-79abad2939c2",
    "author_name": "Isabete Silva",
    "comment": "Todos os conteúdos são maravilhosos, amei! Estou sempre olhando a plataforma. Professores espetaculares, assuntos importantíssimos. Gratidão aos coordenadores, professores e convidados.",
    "rating": 5,
    "review_created_at": "2025-10-07"
  },
  {
    "id": "86c5c483-f550-4bd1-88a0-9578975ea7ae",
    "author_name": "Marcio Sousa",
    "comment": "Muito aproveitador este conteúdo",
    "rating": 5,
    "review_created_at": "2025-09-07"
  },
  {
    "id": "f9c92304-b405-4b0e-adc5-179f8e0fc929",
    "author_name": "Anderson Azevedo",
    "comment": "Melhores cursos que já assisti. Fiz minha inscrição com receio, um pouco traumatizado com outros cursos que não entregam nada do que prometem. Mas me surpreendi muito positivamente: os cursos são bem embasados, com explicações completas. Não é dito apenas o quê, mas também o porquê, que é o mais importante. Recomendo demais.",
    "rating": 5,
    "review_created_at": "2025-09-07"
  },
  {
    "id": "2873bfc4-5753-4588-bad7-421d3ae5d38d",
    "author_name": "Camila Vaz",
    "comment": "Incrível! Aulas de qualidade de maneira gratuita e com certificação! Parabens!",
    "rating": 5,
    "review_created_at": "2025-08-07"
  },
  {
    "id": "9b0bfa9d-00bf-49eb-9eef-11f5a294d2cb",
    "author_name": "Raquel Silva",
    "comment": "Professores incríveis, super capacitados.",
    "rating": 5,
    "review_created_at": "2025-08-07"
  },
  {
    "id": "4bae7876-c39d-4331-bd95-060608955e3f",
    "author_name": "Alexandre Schulz Sartori",
    "comment": "Excelente escola e plataforma de cursos. Profissionais referência na área, especialistas com vasto conhecimento. Vale muito a pena, recomendo muito.",
    "rating": 5,
    "review_created_at": "2025-08-07"
  },
  {
    "id": "bf19bf40-b9ee-4720-85be-db551eb6e4e5",
    "author_name": "Igor Silva",
    "comment": "Professores capacitados, plataforma de fácil navegação, conteúdo PBE. Muito bom!",
    "rating": 5,
    "review_created_at": "2025-08-07"
  },
  {
    "id": "3a4b184c-285f-4644-b4c9-68764a27019b",
    "author_name": "Felipe Lima",
    "comment": "Melhor e mais qualificado portal de ensino de fisioterapia no país!!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "31dae10f-4c3a-423d-8e96-17dcb784e03b",
    "author_name": "Roberta Ormando Hernandes",
    "comment": "A MELHOR plataforma de Ensino on line, os melhores professores e fisioterapeutas estão aqui! Parabéns, tenho certeza absoluta que vocês estão revolucionando a Fisioterapia no Brasil (e mundial)",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "d97e8341-626c-4c2c-aca7-5a6098747706",
    "author_name": "Júnior Fontes",
    "comment": "Conteúdo excelente, site bem organizado! Muito bom",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "010f27f0-9274-42b8-9ced-359918ae2332",
    "author_name": "Janaina Barros",
    "comment": "Site excelente, com profissionais capacitados, cursos e pós graduações de alta qualidade e reconhecidos pelo MEC. Recomendo",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "c81899bc-8bd3-4c5c-ad86-94fd29a097d6",
    "author_name": "VAGNER NEVES",
    "comment": "Conteúdo muito bom, professores capacitados, tô gostando muito.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "993dcffe-3d72-4c43-92aa-2ea0040741f8",
    "author_name": "Jessica Toreti",
    "comment": "Excelente plataforma, faço parte da comunidade há pelo menos 3 anos, e mesmo não sendo da área de ortopedia não abro mão, conteúdo de excelente qualidade.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "9a4b4ab4-7a91-4ae0-8b36-a355b7ee433c",
    "author_name": "Millene Beatriz",
    "comment": "O melhor portal para se aprender sobre Fisioterapia, sempre atualizado e com profissionais de excelência. Muito obrigada por viabilizar essa oportunidade para nós graduandos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "fd41f864-92fd-47a7-91a5-8b7fb7452686",
    "author_name": "Bruno Teixeira Fisioterapeuta",
    "comment": "Sem dúvidas o Fisio em Ortopedia, é uma das melhores plataformas de ensino dentro da Fisioterapia! Sempre alinhando as melhores evidencias cientificas a prática clínica fisioterapêutica, com conteúdos de altíssimo nível e um corpo docente de altíssimo nível técnico!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "6ad2de08-a62c-45af-8c02-5ef8c2b00d00",
    "author_name": "Erica De Jesus Lyra",
    "comment": "Muito bom aprendizado parabéns pelo ensino",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "f84f6279-85b2-4fa1-99dd-32fb3828c1ee",
    "author_name": "rita de cassia martins",
    "comment": "muito boa as aulas e tbm de fácil acesso a plataforma",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "6185a957-cad5-4e48-9935-698264f5d156",
    "author_name": "Sanaya Tavares",
    "comment": "Amo!!! Informações atualizadas, de fácil entendimento e muito prático de assistir!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "5de13fb2-de1f-4659-8f1c-771c85e0756d",
    "author_name": "Cris Moura",
    "comment": "Uma das melhores descobertas após a minha graduação em fisioterapia. Tem feito muita diferença em meus atendimentos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "082222d2-388b-4d3c-aa3d-153430098747",
    "author_name": "Emilio Sciammarella Junior",
    "comment": "Fisioemortopedia foi um divisor de águas na mina carreira. Profissionais altamente capacitados que mudaram a minha prática clínica.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "ce8b46c0-1a86-42d4-b81e-32a82112925b",
    "author_name": "Gabriela Orsatto Soares",
    "comment": "É maravilhoso! A plataforma é incrível",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "8d232942-7c79-4d81-89ac-0ca4beb505bc",
    "author_name": "Tiago Almeida",
    "comment": "Muito bom, qualidade tem nome",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "7bd92dbf-82e0-4aa4-885e-13c599180f78",
    "author_name": "Sunamita Miranda",
    "comment": "Amei o conteúdo. Super recomendo",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "66c613d2-814b-460b-9f58-190437311e13",
    "author_name": "Tiago Rodrigues",
    "comment": "Adoro os cursos e conteúdos da plataforma",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "d7b95e83-564b-4678-8d8c-8c689b72bf40",
    "author_name": "home care enfermagem",
    "comment": "Excelentes conteúdos, estão todos de parabéns",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "8673859b-3e2c-4c3d-a81f-5cf6b125eb22",
    "author_name": "Bruno Lombardi",
    "comment": "Já tive aula com esses professores na Unip, na Pós-Graduação UNIP. Ótimo revê-los novamente agora em cursos como este. Obrigado por dividirem seus conhecimentos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "58bb223e-c595-4e2a-8e61-d37e9f4badf1",
    "author_name": "Gustavo Kanashiro",
    "comment": "Cursos completos, bem explicados e objetivos, apresenta tanto cursos mais extensos com valores bons como cursos rápidos e gratuitos, além de revistas e congressos com informações importantes para atualização de estudos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "d9045662-7274-4a0d-9f85-51a79d092706",
    "author_name": "João Tucunduva",
    "comment": "Excelente experiência realizando a Especialização em Dor e a Pós-Graduação em Atividade Física e Esporte. Aulas excelentes, com professores de qualidade e reconhecidos.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "7a0d50b5-d739-4498-a1ec-7c2cc806d610",
    "author_name": "Isabella Zafanelli",
    "comment": "Já assino a plataforma faz anos e o conteúdo é muito bom! Profissionais atualizados e que passam a informação de forma fácil e organizada.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "67ab7fca-c56c-4bdb-b094-d36f30af049a",
    "author_name": "germana Santos",
    "comment": "Excelente, vale muito a pena participar e estudar, temos todo suporte necessário.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "34ccc0af-7f50-4ea5-9f42-c8f0fc93de41",
    "author_name": "Lorena Oliveira",
    "comment": "Super recomendo, os professores são excelentes, conteúdos atualizados e baseados em ciência, valor super acessível, vale cada investimento.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "5cc00ca9-3176-4ff5-9802-78868f8c3b03",
    "author_name": "Juliana Cristo",
    "comment": "Tive uma excelente experiência ao realizar a pós-graduação em dor para fisioterapeutas. Aulas excelentes, com professores de qualidade e reconhecidos. Didática ótima. Além da preocupação com os alunos, pois, após o ocorrido das enchentes no Rio Grande do Sul, tivemos um prazo a mais para finalizar a pós-graduação. Recomendo sempre o Fisio em Ortopedia.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "57bd6afd-3eb4-4967-8b43-d9f38c96a26c",
    "author_name": "Yasmin El Hage",
    "comment": "Conteúdos da plataforma são super relevantes, de extrema qualidade, corpo docente de altíssimo nível! É uma satisfação imensa ser professora e tb aluna da FeO.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "4d0eadf0-54b7-4fdf-bdc5-b564f1c1d7a6",
    "author_name": "Kelly Faria",
    "comment": "Excelentes, tem me ajudado muito, ainda mais como sou recém-formada.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "64462f1e-ae64-4bd1-9f6d-5aa7b79c10d1",
    "author_name": "Rodrigo Fernandes",
    "comment": "Plataforma de ensino de extrema qualidade técnica e científica. Possui uma carteira de professores de renome. Vídeos muito bem elaborados e com qualidade exemplar. Sem contar os inúmeros conteúdos extras disponíveis no ecossistema Fisioemortopedia. Sou usuário da plataforma Star, pós-graduado em Traumato-Ortopedia, consumidor assíduo dos podcasts.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "e3de3c5f-7bf0-49f7-a49a-693b3b86a03c",
    "author_name": "Eduardo Pixu",
    "comment": "Muito bom os conteúdos deles que eles entregam de graça. Já já vou fazer o pago só pelo que já me entregaram no 0800.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "83cb1254-6266-496b-9cbe-18c0478d0189",
    "author_name": "Letícia Gonçalves",
    "comment": "Plataforma sem igual! Desde a graduação conheço e consumo conteúdos do Fisio em Ortopedia. Agora iniciei meu curso de pós-graduação em dor pelo portal também. Professores são referências no cenário da fisioterapia, de fácil acesso e comunicação, além da didática ser ótima.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "f94a1e7c-5faa-4a58-a99d-f3602ad54ec2",
    "author_name": "DIEGO ANSELMO",
    "comment": "Parabenizo a todos os professores e profissionais envolvidos da Fisio em Ortopedia! Desde a organização da plataforma de acesso, aos conteúdos e materiais disponibilizados. As aulas têm somado muito na minha rotina e, sem dúvidas, eu super indico!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "34fe6ab7-14e4-4da9-829b-288fdfd83d71",
    "author_name": "sarah lehmkuhl fisioterapia",
    "comment": "É um portal completo, estou fazendo a pós-graduação em fisioterapia esportiva e trazem pontos muito importantes sobre o modelo biopsicossocial, olhar para o indivíduo como um todo, assuntos baseados na prática baseada em evidências. Um corpo docente excelente, sem contar o acesso a vários conteúdos valiosos que estão reproduzidos para a prática.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "01edd82c-20a4-43ff-b4c2-848ebe13be2e",
    "author_name": "Fernanda França Gomes",
    "comment": "Os professores são bem preparados e capacitados, as aulas são muito didáticas! Adoro a plataforma, indico demais!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "974206a7-01ca-4d76-aac0-fd4e78791c18",
    "author_name": "Luciana Alves",
    "comment": "Professores incríveis, super capacitados. Os cursos e eventos oferecidos são muito bem organizados e sérios. Recomendo a Fisio em Ortopedia a todos que querem aprender e praticar com base em evidências! A plataforma de ensino é bem intuitiva e as aulas são de excelente qualidade, bem didáticas, sem enrolação.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "bcdbfba5-32b1-4005-9a91-f81ee33450a3",
    "author_name": "Eduardo Santos",
    "comment": "Pós excelente. Aprendo diariamente com os conteúdos baseados em evidência da equipe do FEO. Só tenho a agradecer por ter um papel tão grande no profissional que sou hoje.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "440345fa-53a2-4190-8aee-63a774c5a820",
    "author_name": "Leandro Bruno",
    "comment": "Só tenho a agradecer ao Fisio em Ortopedia. Conteúdos de extrema relevância, professores clínicos e acadêmicos. Aliando a melhor evidência à prática clínica. Discussões profundas em todos os ambientes de aprendizado. Recomendo demais essa turma!",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "68ab8ab6-4fde-4962-8191-9e014eb23b75",
    "author_name": "wanessa sousa",
    "comment": "Eu amo esse site, as aulas são bem didáticas e o layout do site é bem intuitivo. Feliz por encontrar materiais gratuitos com tanta qualidade.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "00108a9f-f8d4-410a-8a4e-040b6192469f",
    "author_name": "Yohanna Pereira Cubillos",
    "comment": "Conteúdo muito didático, vários conteúdos, aulas não são longas e exaustivas, são bem divididas em blocos, facilitando para organizar os estudos. Muito bom.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "12263737-ce10-4c7b-83e9-6284f99c0f65",
    "author_name": "Monica Mendes Barbosa",
    "comment": "Excelente plataforma de ensino! Estou extremamente satisfeita com a experiência que tive. A plataforma é intuitiva, fácil de navegar e os conteúdos são organizados de forma clara e acessível.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "5eae2488-2acd-4e09-ac48-fa0ef13d5fc5",
    "author_name": "Jessica Xavier de Sa Morais",
    "comment": "Muito feliz com a oportunidade de poder estudar com excelentes profissionais e com conteúdo programático fantástico! A disponibilidade de proporcionar treinamentos e cursos que possam enriquecer nossa carreira acadêmica e profissional. Feliz! Super indico.",
    "rating": 5,
    "review_created_at": "2025-07-07"
  },
  {
    "id": "c1e53cc7-11a8-4923-af7d-d60a4aa2ddc5",
    "author_name": "Priscila Chaves",
    "comment": "A melhor iniciativa da Fisioterapia para os Fisioterapeutas não só do Brasil pois moro em Portugal e me beneficio muito com os conteúdos da melhor qualidades. Sou assinante da Star e não poderia estar mais satisfeita.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "c6c21eea-9102-4d7c-88d4-5becb2b37882",
    "author_name": "Deise Daniele Dick",
    "comment": "Super recomendo! Melhor plataforma de educação continuada para fisioterapeutas! Conteúdo SEMPRE excelente! Recomendo as pós-graduações, a plataforma STAR e todos materiais elaborados por esse grupo!",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "62d589ad-d559-41b1-a470-8ddb68d1d1a4",
    "author_name": "Aline Ferreira",
    "comment": "Sou apaixonada pelo Fisio em Ortopedia, além dos cursos pagos eles têm muito conteúdo gratuito que é completamente enriquecedor, são conteúdos pertinentes para quem está na graduação, para quem já formou está estudando para provas com tema em ortopedia/esportiva. Simplesmente amo!!",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "c7acd9d6-7d90-47a9-ba2a-1ee076b77cbb",
    "author_name": "Asha Donini",
    "comment": "É um ponto de virada na história da Fisioterapia musculoesquelética no Brasil. O portal está, de fato, ressignificando o papel do fisioterapeuta em tempos modernos. Aulas ágeis e atualizadas com as principais referências da área.... Cito aqui a Anamaria Siriani de Oliveira, a Nayra Rabelo, a Isa Oliveira, o Leandro Fukusawa dentre outros.... Fiz a pós graduação em Ortopedia e Traumatologia, que me abriu muitas portas e me ajudou a desenvolver um raciocinio clínico diferenciado.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "43bcc1aa-d434-4ee6-848b-9bafa8f6463a",
    "author_name": "Jéssica Béda",
    "comment": "Um marco na fisioterapia brasileira. Conteúdos de excelente qualidade, disponíveis de forma prática para qualificar nossa atuação.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "872b16a7-a2dc-4658-8b4d-fb8725a56c90",
    "author_name": "Samy Gs",
    "comment": "Gratificante, professores qualificados e com ótimo intendimento do assunto abordado, e com cursos ótimos para adquirir conhecimento.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "5ab65aea-0472-40bc-acaa-568e3e268334",
    "author_name": "Gerhard",
    "comment": "Excelentes profissionais e cursos de uma Maneira Geral. Parabéns!",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "548a84df-ea83-4538-b84e-029535026dd5",
    "author_name": "Ayane Victoria",
    "comment": "Plataforma incrível, me ajuda muito nos estudos para a faculdade.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "09bc3790-5e64-4a36-b297-589ea628705f",
    "author_name": "Roberta Rubiane Vaz Teodoro Rocha",
    "comment": "Conteúdos de altíssima qualidade baseados em evidências científicas. Profissionais de altíssimo gabarito. Recomendo. Conteúdos pagos e gratuitos.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "cafc0ac4-45b5-4087-9c97-34f654008dd8",
    "author_name": "Carolina Akiko R Nakazuna",
    "comment": "Conteúdo incrível. Professores altamente qualificados a um valor super acessível. Recomendo para quem ainda é estudante ou já é formado na área da fisioterapia ou que queira se aprofundar em temas relacionados ao sistema musculoesquelético.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "e6898cc0-9dd8-4e46-8f9f-46f86d4da2f0",
    "author_name": "Aline Gonçalves",
    "comment": "Sem dúvida, a melhor escolha que fiz foi fazer minha Especialização em Dor pela FeO. Além de conteúdos riquíssimos e de qualidade, abriu novos horizontes no meu processo de aprendizagem e me deu oportunidades que com certeza estarão presentes em todas as boas recordações, decisões e escolhas.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "21fbda1d-d121-4b34-b721-3018e44677d4",
    "author_name": "Marcio Jaques",
    "comment": "Fui consumidor desde o início, das postagens e cursos de extensão. Depois fui aluno da primeira turma da Pós-graduação da FeO, da qual me tornei um profissional muito melhor. Continuo na plataforma Star, me aperfeiçoando constantemente.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "be1550c8-697b-479a-accb-90d54a954f28",
    "author_name": "aline alves",
    "comment": "Recomendo muito! Já assistia a alguns vídeos gratuitos no YouTube e sempre entregaram conteúdo de qualidade. Então assinei o portal e é simplesmente a melhor plataforma de estudos que existe. Os professores e as aulas são excelentes.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "3e5a1176-66cd-4796-a2c2-d6d7c5b499ff",
    "author_name": "valdemir pereira",
    "comment": "Sou assinante da plataforma Star, estou muito satisfeito com tanto conteúdo de qualidade e professores do mais alto nível. Parabéns a todos!!",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "e7ff7438-a8b1-4e48-af72-01d607b02b60",
    "author_name": "Igor C. S. de Andrade",
    "comment": "Certamente o melhor portal da fisioterapia mundial. Repito: mundial. Não há nada que se compare. Eu sou consumidor dessa marca e recomendo, sem sombra de dúvidas. Inclusive os conteúdos da STAR têm me ajudado muito a alavancar meu consultório virtual. Depois de 15 anos de formado precisei me reinventar e é essa galera que tem me ajudado. Obrigado FEO, de coração.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "2ce2a429-e18b-4d11-a22f-1b0e2b2c6089",
    "author_name": "Thaynara Cerqueira",
    "comment": "A plataforma é ótima. Além das vídeo aulas, eles disponibilizam o PDF, isso deixa o estudo mais dinâmico. Perfeito pra quem é disciplinado e sabe o que quer.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "7617a1f7-abcf-46de-a08e-cfb6c3d5ab39",
    "author_name": "Joice Cristina C Santos",
    "comment": "Um portal com inúmeras oportunidades para fisioterapeutas. Com cursos gratuitos, pós-graduações reconhecidas pelo Ministério da Educação, um corpo docente altamente qualificado e com referências do mercado. Além de uma plataforma com cursos novos todos os meses. Admiro muito o trabalho do Portal!",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "c40b43e9-51d0-4462-bee2-35334c1c3ba3",
    "author_name": "Steffani Pinheiro",
    "comment": "Excelente portal de ensino! O conteúdo é abrangente, atualizado e apresentado de forma clara e acessível. Os professores são altamente qualificados e demonstram um profundo conhecimento na área a qual lecionam, tornando o aprendizado leve e efetivo.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "9ab64f15-ac30-413e-b7da-016e970a77de",
    "author_name": "Ailana Campos",
    "comment": "Os conteúdos em diversas plataformas, seja no YouTube ou como podcast, facilitam o acesso às informações. São temas super relevantes, apresentados por profissionais de excelência e com muita base científica.",
    "rating": 5,
    "review_created_at": "2024-07-07"
  },
  {
    "id": "6e3ed9a1-8b56-41be-ba8c-624236b53014",
    "author_name": "Laísa Maiara",
    "comment": "A pós fisioemortopedia era a pós que todos precisam ter, pois acrescentam muito conhecimento atualizado e baseado em evidencias, com certeza vem me agregando muito conhecimento tanto pelo conteúdo, quanto pela plataforma e a maneira em que ela é executada, fora os profissionais qualificados e super atenciosos e dedicados a todos nós, só tenho a agradecer, era o que faltava na minha carreira dar dar um super profissional.",
    "rating": 5,
    "review_created_at": "2021-07-07"
  },
  {
    "id": "513a5585-3888-42ab-8ffb-2d2886943d3d",
    "author_name": "Raquel Taumaturgo",
    "comment": "Excelente. Assuntos e conteúdos atualizados com professores que são preocupados com a evolução e o melhor desempenho da nossa profissão. Parabéns pelo portal e todas as propostas educacionais que favorecem o nosso crescimento e o melhor desenvolvimento profissional.",
    "rating": 5,
    "review_created_at": "2021-07-07"
  }
];
